<template>
    <span class="ah-el-select-bank-account">
        <el-select
            class="text-cursor"
            v-model="inputVal"
            placeholder="請選擇"
            no-data-text="無資料"
            no-match-text="無相關資料"
            :filterable="true"
            :filter-method="filterMethod"
            :disabled="disabled"
            :size="size"
            @change="handleChange"
            @visible-change="onVisibleChange"
            @keydown.native.capture.enter="preventIMESelect"
            :multiple="multiple"
            reserve-keyword
        >
            <component :is="allowCash ? 'el-option-group' : 'div'" label="銀行帳戶付款">
                <el-option class="account-item" :label="nullLabel" :value="null" v-if="enableNull" :key="null">{{ nullLabel }}</el-option>
                <el-option
                    class="account-item"
                    v-for="item in filteredOptionsCopy"
                    :key="item.sno"
                    :label="`${item.tpc}${!item.enableDocumentInUse || !checkIsEnabledInDocument(item) ? '（已停用）' : ''}`"
                    :value="item.sno"
                    :disabled="(cny && cny != item.cny) || item.disabled"
                >
                    <div class="main clearfix" :class="{ 'show-balance': showBalance }">
                        <div class="name">{{ item.tpc }} <span v-if="!item.enableDocumentInUse || !checkIsEnabledInDocument(item)">（已停用）</span></div>
                        <div class="dep">{{ item.cny }}</div>
                    </div>
                    <div class="sub">
                        <div v-if="!checkIsAhooBank(item)" class="acc">{{ item.bnK_ACC }}</div>
                        <div v-else class="acc">暫存戶</div>
                    </div>
                    <div v-if="showBalance" class="sub">
                        <div class="acc">餘額：{{ item.amt.toLocaleString("en-US") }}</div>
                    </div>
                </el-option>
            </component>
            <el-option-group v-if="allowCash" label="零用現金">
                <el-option label="零用現金付款" :value="cashBnkSno" />
            </el-option-group>
        </el-select>
    </span>
</template>
<script>
import _ from 'lodash';

export default {
    name: 'ah-el-select-bank-account',
    props: {
        value: [Number, Array],

        disabled: Boolean,
        enableNull: Boolean,
        multiple: Boolean,
        hideBorrower: Boolean,
        showLoanBank: Boolean,
        allowCash: Boolean,
        cashBnkSno: {
            type: Number,
            default: -1,
        },
        showBalance: Boolean,

        cny: String,
        size: String,
        nullLabel: String,

        list: Array,
        disabledOption: Object,
        documentType: String,
        showDeactivate: Boolean,
    },
    components: {},
    data() {
        return {
            options: [],
            optionsCopy: [],
            keepVisibleSno: -1,
        };
    },
    computed: {
        inputVal: {
            get() {
                this.updateKeepVisibleSno(this.value);
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        filteredOptionsCopy() {
            let filtered = this.optionsCopy;

            filtered = this.optionsCopy
                .filter((o) => (this.cny ? o.cny === this.cny : true))
                .filter((o) => (this.hideBorrower ? !o.isBorrower : true))
                .filter((o) => (this.showLoanBank ? true : o.bnK_BOO && o.bnK_DOO))
                .filter((o) => (this.showDeactivate ? true : o.enableDocumentInUse))
                .filter((o) => (this.keyMap > 0 ? o.documentInUse.includes(this.keyMap) : true));

            if (this.keepVisibleSno >= 0) {
                const keepItem = this.optionsCopy.find((o) => o.sno === this.keepVisibleSno);
                if (keepItem && !filtered.some((o) => o.sno === this.keepVisibleSno)) filtered.push(keepItem);
            }

            if (this.disabledOption) {
                filtered = _.map(filtered, (item, index) => {
                    const rObj = { ...item };
                    const FOUND = _.findIndex(filtered, (findItem) => findItem.sno === this.disabledOption.sno);
                    if (index === FOUND) rObj.disabled = true;
                    return rObj;
                });
            }

            return filtered;
        },
        keyMap() {
            switch (this.documentType) {
            case 'payment':
                return 1;
            case 'invoice':
                return 2;
            case 'variable-statement':
                return 3;
            case 'transfer':
                return 4;
            case 'petty-cash':
                return 5;
            case 'loan':
                return 6;
            case 'salary':
                return 7;
            default:
                return 0;
            }
        },
    },
    async mounted() {
        if (!this.list) {
            await this.fetchData();
        } else {
            this.options = this.list;
            this.optionsCopy = this.options.filter(() => true);
        }
        // 如果只有一個帳戶，則預選該帳戶
        if (this.options.length === 1) {
            this.inputVal = this.options[0].sno;
        }
    },
    methods: {
        // 取得下拉選單資料
        async fetchData() {
            let apiCategory;
            switch (this.documentType) {
            case 'payment':
                apiCategory = 'PaymentManagenmentPage';
                break;
            case 'invoice':
                apiCategory = 'InvoiceManagemnetPage';
                break;
            case 'variable-statement':
                apiCategory = 'VariableStatementSettingPage';
                break;
            case 'transfer':
                apiCategory = 'AccountTransferRecord';
                break;
            case 'petty-cash':
                apiCategory = 'FundManagementPage';
                break;
            case 'loan':
                apiCategory = 'LoanReceipt';
                break;
            case 'salary':
                apiCategory = 'SalaryManagementPage';
                break;
            default:
                apiCategory = 'Tool';
            }

            const resp = await this.$api({
                url: `/${apiCategory}/GetBankAccountOptions`,
                method: 'GET',
            });

            if (resp && resp.data && resp.data.options) {
                this.options = resp.data.options;
                // 如果目前的值不在選項中，表示該帳戶已被停用，需額外加入該選項
                if (this.inputVal && !this.options.find((o) => o.sno === this.inputVal)) {
                    const fullOptionsResp = await this.$api({
                        url: '/Tool/GetBankAccountOptions',
                        method: 'GET',
                    });
                    const OLD = fullOptionsResp.data.options.find((o) => o.sno === this.value);
                    this.options.push({ ...OLD, amt: 0, tpc: `${OLD.tpc}（已停用）` });
                }
                this.optionsCopy = this.options.filter(() => true);
            }
        },

        // 輸入時過濾方法
        filterMethod(val) {
            // 搜尋
            if (val) {
                this.optionsCopy = this.options.filter((item) => {
                    // 比對
                    if (this.cny) {
                        return (item.tpc.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.bnK_ACC.toLowerCase().indexOf(val.toLowerCase()) > -1) && item.cny == this.cny;
                    }
                    return item.tpc.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.bnK_ACC.toLowerCase().indexOf(val.toLowerCase()) > -1;
                });
            } else if (this.cny) {
                this.optionsCopy = this.options.filter((item) => item.cny == this.cny);
            } else this.optionsCopy = this.options.filter(() => true);
        },
        onVisibleChange() {
            setTimeout(() => {
                this.filterMethod();
            }, 100);
        },

        handleChange(val) {
            const currOption = this.options.find((item) => item.sno == val);
            this.$emit('change', currOption);
        },

        checkIsAhooBank(item) {
            return item.bnK_BOO === '000' && item.bnK_DOO === '000000';
        },
        updateKeepVisibleSno(value) {
            this.keepVisibleSno = value;
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },

        checkIsEnabledInDocument(row) {
            if (!this.documentType) return true;

            const { keyMap } = this;
            return row.documentInUse.includes(keyMap);
        },
    },
};
</script>
<style lang="scss">
.ah-el-select-bank-account {
    .el-input {
        min-width: 200px;
        width: 100%;
    }

    .el-input > input {
        cursor: text;
    }
}

.el-select-dropdown__item.account-item {
    padding-top: 3px;
    height: 65px;

    .main {
        display: block;
        &.show-balance {
            line-height: 24px;
        }

        .name {
            float: left;
            padding-top: 0px;
            height: 28px;
        }

        .dep {
            float: right;
            margin-left: 10px;
            font-size: 9pt;
            font-weight: normal;
            color: #bbb;
        }
    }

    .sub {
        .acc {
            position: relative;
            top: -5px;
            font-size: 9pt;
            color: #ccc;
            height: 15px;
            line-height: 15px;
            font-weight: normal;
        }
    }

    .clearfix:before,
    .clearfix:after {
        content: "";
        display: table;
    }

    .clearfix:after {
        clear: both;
    }

    .clearfix {
        *zoom: 1;
        /*For IE 6&7 only*/
    }
    &::marker {
        display: none;
        line-height: 0;
    }
}
</style>
